import { render, staticRenderFns } from "./PlatformWithdraw.vue?vue&type=template&id=13dba274&scoped=true&"
import script from "./PlatformWithdraw.vue?vue&type=script&lang=js&"
export * from "./PlatformWithdraw.vue?vue&type=script&lang=js&"
import style0 from "./PlatformWithdraw.vue?vue&type=style&index=0&id=13dba274&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13dba274",
  null
  
)

export default component.exports